module.exports = __webpack_public_path__ + "img/king.2c7eaa17.png";